import React from "react";
import PageTitle from "../PageTitle";
import { message, Switch } from "antd";
import {
  DashBoardIcon,
  LibraryIcon,
  MessagesIcon,
  ScheduleIcon,
} from "../../../Core/LayoutV2/LayoutIcons";
import { RightArrowIcon } from "../../../Core/svgV2/RightArrow";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../Core/redux/hooks";
import {
  addDummyDataForDashboardScreen,
  resetToInitialDashBoard,
  updateDashboard,
} from "../../../Core/redux/slices/dashboard.slice";
import { key } from "localforage";
import {
  addDummyDataForMessagesScreen,
  resetToInitialConversation,
  updateConversations,
} from "../../../Core/redux/slices/conversations.slice";
import {
  addDummyDataForScheduleScreen,
  resetToInitialSchedule,
  updateSchedule,
} from "../../../Core/redux/slices/schedule.slice";
import {
  addDummyDataForVaultScreen,
  updateVault,
} from "../../../Core/redux/slices/vault.slice";
import LibraryAppTour from "../../Library/LibraryAppTour";
import {
  addDummyDataForProject,
  resetToInitialProjects,
} from "../../../Core/redux/slices/projects.slice";
import {
  conversationsDummyData,
  dashboardDummyData,
  overViewDummyData,
  projectDummyData,
  scheduleDummyData,
  vaultDummyData,
} from "../../../Core/dummyData";
import {
  addDummyDataForOverviewScreen,
  resetToInitialOverview,
} from "../../../Core/redux/slices/overview.slice";

const Card = ({ icon: Icon, title, onClick }) => {
  return (
    <div className="rounded-lg border border-gray-200 px-3 py-2.5 w-[201px]">
      <Icon className="text-gray-500" />
      <div className="out-500-14 text-gray-700 mt-2">{title}</div>
      <div className="flex gap-x-2 mt-3" onClick={onClick} role="button">
        <div className="out-500-14 text-primary-700">Take The Tour</div>
        <RightArrowIcon className="text-primary-700" />
      </div>
    </div>
  );
};

const StartGuide = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { toursPopup } = useAppSelector((state) => state.dashboard);

  const startTour = (tourType) => {
    message.info("Preparing tour data, please wait...");
    const projectId = scheduleDummyData.phases?.[0]?.projectId || "1";
    dispatch(addDummyDataForProject(projectDummyData));
    dispatch(addDummyDataForOverviewScreen(overViewDummyData));

    localStorage.setItem("appTour", "1");

    switch (tourType) {
      case "dashboard":
        localStorage.removeItem("DashboardTour");
        dispatch(addDummyDataForProject(projectDummyData));
        dispatch(addDummyDataForDashboardScreen(dashboardDummyData));
        dispatch(addDummyDataForOverviewScreen(overViewDummyData));
        localStorage.setItem("appTour", "1");
        dispatch(
          updateDashboard({ key: "takeTourFromWelcomeCard", value: true })
        );
        navigate("/dashboard");
        break;

      case "messages":
        localStorage.removeItem("MessageTour");
        dispatch(addDummyDataForMessagesScreen(conversationsDummyData));
        dispatch(addDummyDataForProject(projectDummyData));
        localStorage.setItem("appTour", "1");
        dispatch(updateConversations({ key: "run", value: true }));
        dispatch(
          updateConversations({ key: "showTakeTourModal", value: false })
        );
        // navigate("/messages");
        break;

      case "schedule":
        localStorage.removeItem("ScheduleTour");
        navigate(`/schedule/${projectId}/timeline`);
        dispatch(addDummyDataForScheduleScreen(scheduleDummyData));
        localStorage.setItem("appTour", "1");
        dispatch(updateSchedule({ key: "run", value: "true" }));
        break;

      case "library":
        localStorage.removeItem("LibraryTour");
        dispatch(addDummyDataForVaultScreen(vaultDummyData));
        localStorage.setItem("appTour", "1");
        dispatch(
          updateVault({
            key: "run",
            value: true,
          })
        );
        dispatch(
          updateVault({
            key: "showTakeTourModal",
            value: false,
          })
        );
        dispatch(
          updateDashboard({
            key: "toursPopup",
            value: { ...toursPopup, libraryTour: false },
          })
        );
        navigate("/library");
        break;
    }
  };

  return (
    <div>
      <PageTitle
        title={"Start Guide"}
        subtext={"Learn how to use the app with our app tours."}
      />
      <div className="flex gap-x-2 mt-6">
        <Switch />
        <div>
          <p className="out-500-14 text-gray-700">App tour settings</p>
          <p className="out-300-12 text-gray-500">
            Always show app tour after creating a new project
          </p>
        </div>
      </div>

      <div className="out-500-14 text-black mt-6">Revisit a tour</div>
      <div className="flex flex-wrap w-[677px] gap-8 mt-6 ">
        <Card
          icon={DashBoardIcon}
          title="Dashboard"
          onClick={() => startTour("dashboard")}
        />
        <Card
          icon={MessagesIcon}
          title="Messages"
          onClick={() => startTour("messages")}
        />
        <Card
          icon={ScheduleIcon}
          title="Schedule"
          onClick={() => startTour("schedule")}
        />
        <Card
          icon={LibraryIcon}
          title="Library"
          onClick={() => startTour("library")}
        />
      </div>
    </div>
  );
};

export default StartGuide;
